module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reservation-action-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('div', {
    staticClass: "stacked-for-small button-group"
  }, [_c('button', {
    staticClass: "button alert",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: ((_vm.item.id) + "/edit"),
          name: 'edit-plan-reservation-rates',
          params: {
            rateId: _vm.item.id
          }
        })
      }
    }
  }, [_vm._v("Edit")]), _c('button', {
    staticClass: "button alert",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bbb82a4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/PlanReservationRateActionButtons.vue
// module id = 2374
// module chunks = 1